import {
  Component,
  Input,
  OnChanges
} from '@angular/core'

@Component({
  selector: 'benchmark-result',
  templateUrl: './benchmark-result.component.html',
  styleUrls: ['./benchmark-result.component.less'],
  standalone: false
})
export class BenchmarkResultComponent implements OnChanges {
  @Input() benchmark: number
  @Input() timePeriod: {name: string, value: string}
  @Input() loadingBenchmarks: boolean
  @Input() benchmarkClassName: string
  @Input() displayAs: 'percentages' | 'values' | 'both' = 'percentages'
  @Input() difference: number
  @Input() differenceFormat: string | {}
  @Input() comparisonDate: string

  tooltip: string

  percentOptions = {
    digits: '1.0-0'
  }

  ngOnChanges() {
    this.tooltip = this.comparisonDate ? `Compared to ${this.comparisonDate}` : null
  }

  abs(value) {
    return Math.abs(value)
  }
}
